import { CardHeader } from "reactstrap";
import { RecentActivity, AdminActivity } from "../../../../Constant";
import { H4, P } from "../../../../AbstractElements";

const AdminActivitiesCardHeader = () => {
  return (
    <CardHeader className=" pb-0">
      <div className="d-flex justify-content-between">
        <div className="flex-grow-1">
          <P attrPara={{ className: "square-after f-w-600 header-text-primary" }}>
            {RecentActivity}
            <i className="fa fa-circle"> </i>
          </P>
          <H4>{AdminActivity}</H4>
        </div>
      </div>
    </CardHeader>
  );
};

export default AdminActivitiesCardHeader;